import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import RegistrationFormService from '../services/RegistrationFormService';
import CardWidgetNewPasswordInputWithErrors from "../../card-widget/error-card-widgets/CardWidgetNewPasswordInputWithErrors";

class PasswordField extends Component {
  constructor(props) {
    super(props);
    this.validateValue('');
  }

  validateValue = (value, isStrongPassword) => {
    this.errorMessage = RegistrationFormService.validatePassword(isStrongPassword);
    this.props.onChange(value, this.errorMessage);
  };

  onChange = (password, isStrongPassword) => {
    this.validateValue(password, isStrongPassword);
  };

  getContent = () => {
    if (this.props.showErrors) {
      return (
          <CardWidgetNewPasswordInputWithErrors
              fieldLabel={this.props.fieldLabel}
              onChange={this.onChange}
              errorMessage={this.errorMessage}
          />
      );
    }
    return (
        <CardWidgetNewPasswordInputWithErrors
            fieldLabel={this.props.fieldLabel}
            onChange={this.onChange}
            errorMessage=''
        />
    );
  };

  render() {
    return (
        <React.Fragment>
          {this.getContent()}
        </React.Fragment>
    );
  }
}

PasswordField.propTypes = {
  onChange: PropTypes.func.isRequired,
  fieldLabel: PropTypes.string,
  showErrors: PropTypes.bool
};

export default PasswordField;